import script from "./external-invested-founder-card.vue?vue&type=script&setup=true&lang=js"
export * from "./external-invested-founder-card.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__